import React from 'react';
import classnames from 'classnames';
import * as Styles from './page-footer.module.less';

export const PageFooter: React.FC = () => (
    <div className={classnames('page-footer', Styles.pageFooter, 'qa-page-footer-div')}>
        <img
            className="qa-page-footer-image"
            src="/assets/images/powered-by-st-copy-2.png"
            alt="ServiceTitan"
            srcSet="/assets/images/powered-by-st-copy-2.png 1x,
                /assets/images/powered-by-st-copy-2@2x.png 2x,
                /assets/images/powered-by-st-copy-2@3x.png 3x"
        />
    </div>
);

export const PageFooterAnchored: React.FC = () => (
    <div
        className={classnames(
            'page-footer',
            Styles.pageFooterAnchored,
            'qa-page-footer-anchored-div'
        )}
    >
        <img
            className="qa-page-footer-image"
            src="/assets/images/powered-by-st-copy-2.png"
            alt="ServiceTitan"
            srcSet="/assets/images/powered-by-st-copy-2.png 1x,
                /assets/images/powered-by-st-copy-2@2x.png 2x,
                /assets/images/powered-by-st-copy-2@3x.png 3x"
        />
    </div>
);
